import React from 'react';

const LoaderCircle = () => {
  return (
    <div className='spinner-border text-light ml-4 h-5 w-5' role='status'>
      <span className='sr-only'>Loading...</span>
    </div>
  );
};

export default LoaderCircle;
